module.exports = __webpack_public_path__ + "components/signup/static/xmark-2d799bb2e6eea66226792b18a7743dc5.svg";